module.exports = __webpack_public_path__ + "static/media/velora.f56db596.svg";